import { useEffect, useRef, useState } from 'react'
import { apiPut } from '../../api'
import type { WeekendPlan } from '../../api'

const enGBLong = new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long' })

interface Props {
  plan: WeekendPlan
  onSaved: () => void
}

const QUICK_CHIPS = ['Walk', 'Pub lunch', 'Cinema', 'No plans, just be']

export default function WeekendPlanner({ plan, onSaved }: Props) {
  const [text, setText] = useState(plan.plan_md)
  const lastSaved = useRef<string>(plan.plan_md)
  const debounce = useRef<number | null>(null)

  useEffect(() => {
    setText(plan.plan_md)
    lastSaved.current = plan.plan_md
  }, [plan.weekend_of, plan.plan_md])

  const save = async (value: string) => {
    if (value === lastSaved.current) return
    try {
      await apiPut('/home/weekend-plan', { weekend_of: plan.weekend_of, plan_md: value })
      lastSaved.current = value
      onSaved()
    } catch { /* silent */ }
  }

  const onChange = (v: string) => {
    setText(v)
    if (debounce.current) window.clearTimeout(debounce.current)
    debounce.current = window.setTimeout(() => save(v), 800)
  }

  const addChip = (label: string) => {
    const next = text ? `${text}\n- ${label}` : `- ${label}`
    onChange(next)
  }

  return (
    <div>
      <div className="secondary" style={{ marginBottom: '0.5rem' }}>
        {enGBLong.format(new Date(`${plan.weekend_of}T00:00:00`))} weekend
      </div>
      <div className="chip-row">
        {QUICK_CHIPS.map(c => (
          <button key={c} type="button" className="chip" onClick={() => addChip(c)}>{c}</button>
        ))}
      </div>
      <textarea
        className="weekend-textarea"
        value={text}
        onChange={e => onChange(e.target.value)}
        onBlur={() => save(text)}
        placeholder="What's on this weekend?"
      />
    </div>
  )
}
